import React, { useContext, useEffect } from 'react'
import { EasybakeContext } from './EasybakeProvider'
import Home from './Home/Home'
import Autotone from './Autotone/Autotone'
import Preset from './Preset/Preset'
import PsActions from './PsActions/PsActions'
import SmartObject from './SmartObject/SmartObject'
import TextLayer from './TextLayer/TextLayer'
import ImageCutout from './ImageCutout/ImageCutout'
import BannerReflow from './BannerReflow/BannerReflow'
import SignUp from './Console/SignUp'
import EnterpriseSetupMeeting from './Console/EnterpriseSetupMeeting'
import AwsMp from './Console/AwsMp'
import SingupForm from './Console/Form'
import Create from './Console/Create'
import CredInfo from './Console/CredInfo'
import AccessToken from './Console/AccessToken'
import HelloWorld from './Console/HelloWorld'
import BuildSomethingCool from './Console/BuildSomethingCool'
import DebugStatus from './DebugStatus'
import { getRef, getDebugMode, getUrlParameter, goToUrlTarget } from '../lib/easybake'
import { connectToParent } from 'penpal';

export default function Main ({ page }) {
    const { ut, dispatch, dMode } = useContext(EasybakeContext)

    window.onload = () => {
        try {
            const connection = connectToParent({
                methods: {
                    onShow: () => {
                        if (window.easybake) {
                            window.easybake.parent.getURL().then((data) => {
                                dispatch({ type: 'set-page', payload: { page: getRef(data) } })
                                dispatch({ type: 'set-dMode', payload: { dMode: getDebugMode(data) } })
                                dispatch({ type: 'set-act', payload: { act: getUrlParameter('act', data) } })
                                window.easybake.parent.setHeight(`660px`);
                            })
                        }
                    },
                    onHide: () => {
                        // console.log('Iframe is hidden');
                    }
                },
                timeout: 5000,
                debug: false
            });

            connection.promise.then((parent) => {
                window.easybake = {
                    parent: parent
                }
                Promise.all([
                    parent.getIMSAccessToken(),
                    parent.getIMSProfile()
                    // parent.getURL()
                ]).then((data) => {
                    if (data[0]) {
                        dispatch({ type: 'set-ut', payload: { ut: data[0] && data[0].token } })
                        window.easybake.parent.setHeight(`660px`);
                    }
                    if (data[1]) {
                        dispatch({ type: 'set-formFullName', payload: { formFullName: data[1].name } })
                        dispatch({ type: 'set-formEmail', payload: { formEmail: data[1].email } })
                    }
                });
            });
        } catch (e) {
            if (!dMode) {
                goToUrlTarget(encodeURI(`${process.env.REACT_APP_CONFIG_APP_EASYBAKE_URL}`), '_top')
            } else {
                const curUrl = new URL(document.location.href)
                const dUt = curUrl.searchParams.get('ut')
                if (dUt) {
                    dispatch({ type: 'set-ut', payload: { ut: dUt } })
                }
            }
        }
    };

    return (
        <React.Fragment>
            {dMode && <DebugStatus />}
            {page === 'home' && <Home />}
            {page === 'autotone' && <Autotone />}
            {page === 'preset' && <Preset />}
            {page === 'psactions' && <PsActions />}
            {page === 'smartobject' && <SmartObject />}
            {page === 'textlayer' && <TextLayer />}
            {page === 'imagecutout' && <ImageCutout />}
            {page === 'bannerreflow' && <BannerReflow />}
            {page === 'signup' && <SignUp referrer={page}/>}
            {page === 'awsmp' && <AwsMp />}
            {page === 'form' && <SingupForm />}
            {page === 'create' && <Create />}
            {page === 'credinfo' && <CredInfo />}
            {page === 'accesstoken' && <AccessToken />}
            {page === 'helloworld' && <HelloWorld />}
            {page === 'buildsomethingcool' && <BuildSomethingCool />}
            {page === 'contactsales' && <SignUp referrer={page}/>}
            {page === 'enterprisesetupmeeting' && <EnterpriseSetupMeeting />}
        </React.Fragment>
    )
}
